/* eslint-disable import/prefer-default-export */
import { type UnwrapRef, ref } from "vue";

import { type Nullable } from "shared/types";
import { isNonNullable } from "shared/types/guards";

interface InputValue<T> {
  current: T;
  previous?: T;
}

export function useValueWithPrevious<T = string>(current: T, previous?: T) {
  const inputValue = ref<InputValue<T>>({ current, previous });

  function update(value: UnwrapRef<Nullable<T>>): boolean {
    if (!isNonNullable(value)) return false;

    const hasChanged = value !== inputValue.value.previous;

    if (hasChanged) {
      inputValue.value.previous = value;
    }

    return hasChanged;
  }

  return {
    value: inputValue,
    update,
  };
}
